import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Daily from "../pages/daily/page";
import Channel from "../pages/channel/page";
import NewsDetail from "../pages/news/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/daily",
    element: <Daily />,
  },
  {
    path: "/channel/:slug",
    element: <Channel />,
  },
  {
    path: "/news/:slug",
    element: <NewsDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;